import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "InfoYellow",
  "use": "InfoYellow-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"InfoYellow\">\n<path d=\"M6.99967 0.333008C3.31967 0.333008 0.333008 3.31967 0.333008 6.99967C0.333008 10.6797 3.31967 13.6663 6.99967 13.6663C10.6797 13.6663 13.6663 10.6797 13.6663 6.99967C13.6663 3.31967 10.6797 0.333008 6.99967 0.333008ZM7.66634 10.333H6.33301V8.99967H7.66634V10.333ZM7.66634 7.66634H6.33301V3.66634H7.66634V7.66634Z\" fill=\"#F7B01C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol